export default "__VITE_ASSET__dc9931b1__"